module.exports = __webpack_public_path__ + "static/media/space.f966256f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/space.svg
// module id = ./src/App/assets/space.svg
// module chunks = 0